import React from 'react'
import { useSelector } from 'react-redux'
import { CssBaseline, makeStyles } from '@material-ui/core'
import { Route, Switch } from 'react-router-dom'

import { NavBar } from '../components/ui/NavBar'
import { DashboardScreen } from '../components/dashboard/DashboardScreen'
import { ReportScreen } from '../components/report/ReportScreen'
import { HistoricScreen } from '../components/historic/HistoricScreen'
import { ReportRayosScreen } from '../components/report/ReportRayosScreen'
import { TWSscreen } from '../components/TWS/TWSscreen'



const useStyles = makeStyles((theme)=>({
    root: {
        display: 'flex',
    },
}))

export const DashboardRoutes = () => {

    const classes = useStyles()

    const auth = useSelector(state => state.auth)

    return (
        <>
            <div className={classes.root}>
                <CssBaseline />
                <NavBar/>
                <Switch>
                    
                    <Route exact path="/tiempoReal" component={DashboardScreen}/>
                    {auth.valitadion.historic === 'True' &&
                        <Route exact path="/historico" component={HistoricScreen}/>
                    }
                    {auth.valitadion.report === 'True' &&
                        <Route exact path="/report" component={ReportScreen}/>
                    }
                    {auth.valitadion.consrayos === 'True' &&
                        <Route exact path="/rayos" component={ReportRayosScreen}/>
                    }
                    {auth.valitadion.crud === 'True' &&
                        <Route exact path="/TWS" component={TWSscreen}/>
                    }
                    {auth.valitadion.tiemporeal === 'True' &&
                        <Route exact path="*" component={DashboardScreen} />
                    }
                    {auth.valitadion.tiemporeal === 'False' &&
                        <Route exact path="*" component={ReportRayosScreen} />
                    }
                    <Route exact path="/ayuda"/>
                </Switch>
            </div>
        </>
    )
}
